import React, { useEffect, useState } from 'react';
import SelectMultiple, { OptionType } from './SelectMultiple';
import usersService from '../../services/users';

interface Props {
  roles: Array<string>;
  onrolesChange: (roles: Array<string>) => void;
}

const SelectRole: React.FunctionComponent<Props> = (props) => {
  const [names, setNames] = useState<string[]>([]);

  useEffect(() => {
    usersService.getRoles().then((roles: Array<{ name: string }>) => setNames(roles.map((role) => role.name)));
  }, []);

  const roles: Array<OptionType> = names.map((name) => ({ label: name, value: name }));
  const selected = roles.filter((role) => props.roles.includes(role.value));

  const onChange = (value: ReadonlyArray<OptionType> | OptionType | null | undefined) => {
    return value && Array.isArray(value) ? props.onrolesChange(value.map((v) => v.value)) : props.onrolesChange([]);
  };

  return (
    <SelectMultiple data={roles} selected={selected} label="Roles" placeholder="Select roles" onChange={onChange} />
  );
};

export default SelectRole;
